import { LocaleProvider } from "@op/opds.opux";
import { createContext, ReactNode } from "react";
import { IntlProvider } from "react-intl";
import messages from "../messages";

const userInfoCtx = createContext({
  language: "fi",
  locale: "FI",
});

const Provider = userInfoCtx.Provider;

type UserInfoProviderProps = {
  children: ReactNode;
};

const UserInfoProvider = ({ children }: UserInfoProviderProps) => {
  const locale =
    document.documentElement.dataset.selectedLang ??
    document.documentElement.getAttribute("lang") ??
    "fi";
  const language = locale?.split("-")[0] ?? "fi";

  return (
    <Provider value={{ language, locale }}>
      <IntlProvider locale={language} messages={messages[language || "fi"]}>
        <LocaleProvider locale={locale}>{children}</LocaleProvider>
      </IntlProvider>
    </Provider>
  );
};

export default UserInfoProvider;
